import Lowlight from "react-lowlight";
// @ts-expect-error - highlight.js library doesn't have type definitions
import json from "highlight.js/lib/languages/json";

export const initializeLowlight = () => {
  Lowlight.registerLanguage("json", json);
};
